type BadgeTone = "neutral" | "info" | "success" | "warning" | "danger";

interface BadgeProps {
  children: string;
  tone?: BadgeTone;
}

const TONE_CLASSES: Record<BadgeTone, string> = {
  neutral: "bg-[#f0f2f5] text-[#77828e]",
  info: "bg-[#edf3fc] text-[#5c87bf]",
  success: "bg-[#e9f4ee] text-[#298166]",
  warning: "bg-[#fff3df] text-[#ac7a29]",
  danger: "bg-[#fbecef] text-[#b44956]",
};

export function Badge({ children, tone = "neutral" }: BadgeProps) {
  return (
    <span
      className={[
        "inline-block rounded-md px-2 py-[5px] text-xs font-medium",
        TONE_CLASSES[tone],
      ].join(" ")}
    >
      {children}
    </span>
  );
}
